import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IVehicle } from "@interfaces/IVehicle";
import { VehicleDataService } from "src/app/main/components/fleetMaintenance/vehicleData.service";
import "./vehicleInfoCard.component.scss";

@Component({
    selector: "vehicle-info-card",
    template: require("./vehicleInfoCard.component.html")
})
export class VehicleInfoCardComponent implements OnChanges {
    @Input() vehicle: IVehicle;
    @Input() hideImage: boolean = false;

    loading: boolean;

    constructor(private vehicleDataService: VehicleDataService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.vehicle || this.vehicle.vehicleData) {
            return;
        }

        this.vehicleDataService.getDataForVehicle(this.vehicle.Id).then(data => {
            this.vehicle.vehicleData = data;

            this.vehicleDataService.calculateMOTAndTaxStatus(this.vehicle, data);
        });
    }
}

//import { IVehicle } from "@interfaces/IVehicle";
//import * as angular from "angular";
//import { VehicleDataService } from "src/app/main/components/fleetMaintenance/vehicleData.service";
//import "./vehicleInfoCard.component.scss";

//interface IVehicleListBindings {
//    vehicle: IVehicle;
//}
//class ComponentController implements angular.IComponentController, IVehicleListBindings {

//    loading: boolean;

//    vehicle: IVehicle;

//    static $inject = ["vehicleDataService"];

//    constructor(
//        private readonly vehicleDataService: VehicleDataService) {
//    }

//    $onInit(): void {
//    }

//    $onChanges(onChangesObj: angular.IOnChangesObject) {
//        if (!this.vehicle || this.vehicle.vehicleData) {
//            return;
//        }

//        this.vehicleDataService.getDataForVehicle(this.vehicle.Id).then(data => {
//            this.vehicle.vehicleData = data;

//            this.vehicleDataService.calculateMOTAndTaxStatus(this.vehicle, data);
//        });
//    }

//    // ---

//}

//export class VehicleInfoCardComponent implements angular.IComponentOptions {
//    bindings: any;
//    controller: any;
//    template: string;

//    constructor() {
//        this.bindings = {
//            vehicle: "<"
//        };

//        this.controller = ComponentController;
//        this.template = require("./vehicleInfoCard.component.html");
//    }
//}


